module.exports = __webpack_public_path__ + "img/about_banner.bb10639a.jpg";